import styled from 'styled-components';

export default styled.img`
  width: 245px;
  height: 250px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-top-right-radius: 0;

  ${({ small }) =>
    small &&
    `
    width: 500px;
    height: 250px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-bottom-left-radius: 0;
    object-fit: cover;
  `}
`;
